const digitos = (valor: string) => valor.replace(/\D/g, '');

/** 11222333000181 → 11.222.333/0001-81, conforme a digitação. */
export function mascaraCnpj(valor: string): string {
  return digitos(valor)
    .slice(0, 14)
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
}

/**
 * (51) 3333-4444 ou (51) 99999-8888. O WhatsApp vem do servidor com o 55 na
 * frente; aqui ele sai para caber na máscara, e o servidor o põe de volta.
 */
export function mascaraTelefone(valor: string): string {
  let d = digitos(valor);
  if (d.length > 11 && d.startsWith('55')) d = d.slice(2);
  d = d.slice(0, 11);

  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}
